export default __webpack_public_path__ + "static/media/Dream hoodie.d00e72bc.jpg";